module.exports = __webpack_public_path__ + "static/media/icon-pet.3f1026eb.svg";